import LoaderIcon from '@components/icons/LoaderIcon';
import RocketIcon from '@components/icons/RocketIcon';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import { useMemo } from 'react';
import { Status, usePaymentAndOrder } from '../../payments/PaymentAndOrderContext';
import { useLandingPageTranslation } from './useLandingPageTranslation';

export default function GoalLandingPageEnrollBanner() {
  const { handleMainAction, state, canEnroll } = usePaymentAndOrder();
  const { t } = useLandingPageTranslation();

  const text = useMemo(() => {
    if (state.status === Status.PENDING_ACTIVATION) {
      return t('domains.payments.CTAs.processing');
    }
    if (state.status === Status.SUBSCRIBED) {
      return t('domains.payments.CTAs.learnNow');
    }
    return t('domains.payments.CTAs.enrollNow');
  }, [state.status]);

  return (
    <div
      className={classNames(
        'flex flex-row items-center justify-center gap-sm px-sm py-lg',
        setupForDark('bg-yellow-700')
      )}
    >
      <div className={classNames('P1M uppercase', setupForDark('text-black'))}>
        {t('domains.payments.CTAs.acquired')}
      </div>
      <div
        onClick={handleMainAction}
        className={classNames(
          'rounded-xs border-[1px] px-sm py-xxs P1M cursor-pointer hover:scale-105 duration-100 uppercase',
          setupForDark('border-black text-black')
        )}
      >
        <div className='flex flex-row items-center gap-xs justify-center'>
          {state.status === Status.PENDING_ACTIVATION && <LoaderIcon size={20} />}
          {canEnroll && <RocketIcon size={20} />}
          {text}
        </div>
      </div>
    </div>
  );
}
